import type { DateBounds } from "../types";
import { isValidDate } from "./isValidDate";

export function boundsFromDisabled(
  disabled?: { before: Date; after: Date } | true,
): DateBounds {
  if (!disabled || disabled === true) return {};
  return {
    min: isValidDate(disabled.before) ? disabled.before : undefined,
    max: isValidDate(disabled.after) ? disabled.after : undefined,
  };
}
